<template>
    <div class="lotto-widget ticket-stack-widget">
        <LottoBetSlip
            :selected="selections"
            :selectionStatuses="selectionStatuses"
            :systems="[]"
            :eventDescription="eventDescription"
            :eventNo="eventNo"
        />
        <SystemRow
            v-if="system"
            v-bind="system"
            :minimumPotentialWin="minimumPotentialWin"
        />
        <TicketTableHeader :isWon="isWon"/>
        <TicketSummary
            class="summary"
            v-bind="$props"
        />
    </div>
</template>

<script>
    import {
        groupBy as _groupBy,
        map as _map,
    } from '@lodash';
    import SystemRow from '@modules/shared/tickets/SystemRow';
    import LottoBetSlip from '@shared/lotto/betSlip/LottoBetSlip.vue';
    import TicketSummary from '../TicketSummary';
    import TicketTableHeader from '../TicketTableHeader';

    export default {
        props: {
            events: {
                type: Array,
                required: true,
            },
            // child props
            id: {
                type: String,
                required: true,
            },
            isWon: {
                type: Boolean,
                required: true
            },
            type: {
                type: String,
                required: true,
            },
            system: {
                type: Object,
                default: null,
            },
            stake: {
                type: Number,
                required: true,
            },
            potentialWin: {
                type: Number,
                required: true,
            },
            minimumPotentialWin: {
                type: Number,
                required: true,
            },
            payoff: {
                type: Number,
                required: true,
            },
            coefficient: {
                type: Number,
                required: true,
            },
            status: {
                type: String,
                required: true,
            },
            numEventsLeft: {
                type: Number,
                required: true
            },
        },
        computed: {
            selections() {
                return this.events.map((e) => parseInt(e.odd.name, 10));
            },
            selectionStatuses() {
                return this.events.map((e) => e.status);
            },
            eventDescription() {
                const event = this.events[0];
                const eventNameTokens = event.name.split('-');
                const [numbersDrawn, totalNumbers] = eventNameTokens[1]
                    .split('/')
                    .map((e) => parseInt(e.trim(), 10));

                return {
                    numbersDrawn,
                    totalNumbers,
                    eventName: eventNameTokens[0].trim(),
                    eventDate: event.date
                };
            },
            eventNo() {
                return this.events[this.events.length - 1].eventNo;
            },
            mappedProps() {
                const {
                    events: _events,
                    ...props
                } = this.$props;
                const events = _groupBy(_events, 'eventId');
                // TODO move this to mappers if the same structure can be used on the tickets page
                const mappedEvents = _map(events, (nestedEvents) => ({
                    name: nestedEvents[0].name,
                    date: nestedEvents[0].date,
                    odds: nestedEvents.map(({
                        odd,
                        status
                    }) => ({
                        status,
                        id: odd.oddId,
                    }))
                }));
                return {
                    events: mappedEvents,
                    itemProps: props,
                };
            },
        },
        components: {
            TicketSummary,
            TicketTableHeader,
            SystemRow,
            LottoBetSlip,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/ticketsWidget/components/LottoWidget/LottoWidgetContent.vue